// src/pages/Privacy.jsx
import PrivacyContent from "./policies/PrivacyContent";

export default function Privacy() {
  return (
    <div className="page">
      <div className="mx-auto max-w-3xl">
        <article className="card prose prose-invert">
          <PrivacyContent />
        </article>
      </div>
    </div>
  );
}
